/**
 * Builds a Flow Viewer URL like `{origin}#/ProcessFlows/{flowId}/{flowVersion}/{recordId}/view`
 * using `env.ProcessFlowDetailsUrl` as a template (any existing flow id / version / record in the path are replaced).
 */
export function buildProcessFlowViewDetailsUrl(processFlowDetailsTemplate, flowId, flowVersion, recordId) {
    const t = processFlowDetailsTemplate.trim();
    if (!t)
        return '';
    const path = `/ProcessFlows/${flowId}/${flowVersion}/${recordId}/view`;
    const replaced = t.replace(/\/ProcessFlows\/[^/]+\/[^/]+\/[^/]+\/view$/i, path);
    if (replaced !== t)
        return replaced;
    const hashIdx = t.indexOf('#');
    const origin = hashIdx >= 0 ? t.slice(0, hashIdx) : t.replace(/\/$/, '');
    return `${origin}#/ProcessFlows/${flowId}/${flowVersion}/${recordId}/view`;
}
